import { css } from 'linaria';
import tokens from './tokens';
import {
    SpacingValues,
    JustifyContentValues,
    DisplayValues,
    AlignItemsValues,
    FlexDirectionValues,
    TextAlignValues,
    OverflowValues,
    WhiteSpaceValues,
    TextOverflowValues,
    MaxWidthValues,
    LineHeightValues,
    SizeValues,
    PositionValues,
    BorderValues,
    RadiusValues,
    CursorValues,
    AppearanceValues,
    OutlineValues,
} from './types';

const minWidth0 = css`
    min-width: ${tokens.sizes['0']};
`;
const minWidth1 = css`
    min-width: ${tokens.sizes['1']};
`;
const minWidth4 = css`
    min-width: ${tokens.sizes['4']};
`;
const minWidth8 = css`
    min-width: ${tokens.sizes['8']};
`;
const minWidth12 = css`
    min-width: ${tokens.sizes['12']};
`;
const minWidth16 = css`
    min-width: ${tokens.sizes['16']};
`;
const minWidth20 = css`
    min-width: ${tokens.sizes['20']};
`;
const minWidth24 = css`
    min-width: ${tokens.sizes['24']};
`;
const minWidth28 = css`
    min-width: ${tokens.sizes['28']};
`;
const minWidth32 = css`
    min-width: ${tokens.sizes['32']};
`;
const minWidth40 = css`
    min-width: ${tokens.sizes['40']};
`;
const minWidth44 = css`
    min-width: ${tokens.sizes['44']};
`;
const minWidth48 = css`
    min-width: ${tokens.sizes['48']};
`;
const minWidth64 = css`
    min-width: ${tokens.sizes['64']};
`;
const minWidth80 = css`
    min-width: ${tokens.sizes['80']};
`;
const minWidth96 = css`
    min-width: ${tokens.sizes['96']};
`;
const minWidth128 = css`
    min-width: ${tokens.sizes['128']};
`;
const minWidth160 = css`
    min-width: ${tokens.sizes['160']};
`;
const minWidth192 = css`
    min-width: ${tokens.sizes['192']};
`;
const minWidth224 = css`
    min-width: ${tokens.sizes['224']};
`;
const minWidth256 = css`
    min-width: ${tokens.sizes['256']};
`;
const minWidthFull = css`
    min-width: ${tokens.sizes.full};
`;
const minWidthMaxContent = css`
    min-width: ${tokens.sizes['max-content']};
`;

const minWidthVariants: Record<SizeValues, string> = {
    '0': minWidth0,
    '1': minWidth1,
    '4': minWidth4,
    '8': minWidth8,
    '12': minWidth12,
    '16': minWidth16,
    '20': minWidth20,
    '24': minWidth24,
    '28': minWidth28,
    '32': minWidth32,
    '40': minWidth40,
    '44': minWidth44,
    '48': minWidth48,
    '64': minWidth64,
    '80': minWidth80,
    '96': minWidth96,
    '128': minWidth128,
    '160': minWidth160,
    '192': minWidth192,
    '224': minWidth224,
    '256': minWidth256,
    full: minWidthFull,
    'max-content': minWidthMaxContent,
};

const width0 = css`
    width: ${tokens.sizes['0']};
`;
const width1 = css`
    width: ${tokens.sizes['1']};
`;
const width4 = css`
    width: ${tokens.sizes['4']};
`;
const width8 = css`
    width: ${tokens.sizes['8']};
`;
const width12 = css`
    width: ${tokens.sizes['12']};
`;
const width16 = css`
    width: ${tokens.sizes['16']};
`;
const width20 = css`
    width: ${tokens.sizes['20']};
`;
const width24 = css`
    width: ${tokens.sizes['24']};
`;
const width28 = css`
    width: ${tokens.sizes['28']};
`;
const width32 = css`
    width: ${tokens.sizes['32']};
`;
const width40 = css`
    width: ${tokens.sizes['40']};
`;
const width44 = css`
    width: ${tokens.sizes['44']};
`;
const width48 = css`
    width: ${tokens.sizes['48']};
`;
const width64 = css`
    width: ${tokens.sizes['64']};
`;
const width80 = css`
    width: ${tokens.sizes['80']};
`;
const width96 = css`
    width: ${tokens.sizes['96']};
`;
const width128 = css`
    width: ${tokens.sizes['128']};
`;
const width160 = css`
    width: ${tokens.sizes['160']};
`;
const width192 = css`
    width: ${tokens.sizes['192']};
`;
const width224 = css`
    width: ${tokens.sizes['224']};
`;
const width256 = css`
    width: ${tokens.sizes['256']};
`;
const widthFull = css`
    width: ${tokens.sizes.full};
`;
const widthMaxContent = css`
    width: ${tokens.sizes['max-content']};
`;

const widthVariants: Record<SizeValues, string> = {
    '0': width0,
    '1': width1,
    '4': width4,
    '8': width8,
    '12': width12,
    '16': width16,
    '20': width20,
    '24': width24,
    '28': width28,
    '32': width32,
    '40': width40,
    '44': width44,
    '48': width48,
    '64': width64,
    '80': width80,
    '96': width96,
    '128': width128,
    '160': width160,
    '192': width192,
    '224': width224,
    '256': width256,
    full: widthFull,
    'max-content': widthMaxContent,
};

const height0 = css`
    height: ${tokens.sizes['0']};
`;
const height1 = css`
    height: ${tokens.sizes['1']};
`;
const height4 = css`
    height: ${tokens.sizes['4']};
`;
const height8 = css`
    height: ${tokens.sizes['8']};
`;
const height12 = css`
    height: ${tokens.sizes['12']};
`;
const height16 = css`
    height: ${tokens.sizes['16']};
`;
const height20 = css`
    height: ${tokens.sizes['20']};
`;
const height24 = css`
    height: ${tokens.sizes['24']};
`;
const height28 = css`
    height: ${tokens.sizes['28']};
`;
const height32 = css`
    height: ${tokens.sizes['32']};
`;
const height40 = css`
    height: ${tokens.sizes['40']};
`;
const height44 = css`
    height: ${tokens.sizes['44']};
`;
const height48 = css`
    height: ${tokens.sizes['48']};
`;
const height64 = css`
    height: ${tokens.sizes['64']};
`;
const height80 = css`
    height: ${tokens.sizes['80']};
`;
const height96 = css`
    height: ${tokens.sizes['96']};
`;
const height128 = css`
    height: ${tokens.sizes['128']};
`;
const height160 = css`
    height: ${tokens.sizes['160']};
`;
const height192 = css`
    height: ${tokens.sizes['192']};
`;
const height224 = css`
    height: ${tokens.sizes['224']};
`;
const height256 = css`
    height: ${tokens.sizes['256']};
`;
const heightFull = css`
    height: ${tokens.sizes.full};
`;
const heightMaxContent = css`
    height: ${tokens.sizes['max-content']};
`;

const heightVariants: Record<SizeValues, string> = {
    '0': height0,
    '1': height1,
    '4': height4,
    '8': height8,
    '12': height12,
    '16': height16,
    '20': height20,
    '24': height24,
    '28': height28,
    '32': height32,
    '40': height40,
    '44': height44,
    '48': height48,
    '64': height64,
    '80': height80,
    '96': height96,
    '128': height128,
    '160': height160,
    '192': height192,
    '224': height224,
    '256': height256,
    full: heightFull,
    'max-content': heightMaxContent,
};

const marginRight0 = css`
    margin-right: ${tokens.spacings['0']};
`;
const marginRight4 = css`
    margin-right: ${tokens.spacings['4']};
`;
const marginRight8 = css`
    margin-right: ${tokens.spacings['8']};
`;
const marginRight12 = css`
    margin-right: ${tokens.spacings['12']};
`;
const marginRight16 = css`
    margin-right: ${tokens.spacings['16']};
`;
const marginRight20 = css`
    margin-right: ${tokens.spacings['20']};
`;
const marginRight24 = css`
    margin-right: ${tokens.spacings['24']};
`;
const marginRight32 = css`
    margin-right: ${tokens.spacings['32']};
`;
const marginRight40 = css`
    margin-right: ${tokens.spacings['40']};
`;
const marginRight48 = css`
    margin-right: ${tokens.spacings['48']};
`;
const marginRight64 = css`
    margin-right: ${tokens.spacings['64']};
`;

const marginRightVariants: Record<SpacingValues, string> = {
    '0': marginRight0,
    '4': marginRight4,
    '8': marginRight8,
    '12': marginRight12,
    '16': marginRight16,
    '20': marginRight20,
    '24': marginRight24,
    '32': marginRight32,
    '40': marginRight40,
    '48': marginRight48,
    '64': marginRight64,
};

const marginLeft0 = css`
    margin-left: ${tokens.spacings['0']};
`;
const marginLeft4 = css`
    margin-left: ${tokens.spacings['4']};
`;
const marginLeft8 = css`
    margin-left: ${tokens.spacings['8']};
`;
const marginLeft12 = css`
    margin-left: ${tokens.spacings['12']};
`;
const marginLeft16 = css`
    margin-left: ${tokens.spacings['16']};
`;
const marginLeft20 = css`
    margin-left: ${tokens.spacings['20']};
`;
const marginLeft24 = css`
    margin-left: ${tokens.spacings['24']};
`;
const marginLeft32 = css`
    margin-left: ${tokens.spacings['32']};
`;
const marginLeft40 = css`
    margin-left: ${tokens.spacings['40']};
`;
const marginLeft48 = css`
    margin-left: ${tokens.spacings['48']};
`;
const marginLeft64 = css`
    margin-left: ${tokens.spacings['64']};
`;

const marginLeftVariants: Record<SpacingValues, string> = {
    '0': marginLeft0,
    '4': marginLeft4,
    '8': marginLeft8,
    '12': marginLeft12,
    '16': marginLeft16,
    '20': marginLeft20,
    '24': marginLeft24,
    '32': marginLeft32,
    '40': marginLeft40,
    '48': marginLeft48,
    '64': marginLeft64,
};

const marginBottom0 = css`
    margin-bottom: ${tokens.spacings['0']};
`;
const marginBottom4 = css`
    margin-bottom: ${tokens.spacings['4']};
`;
const marginBottom8 = css`
    margin-bottom: ${tokens.spacings['8']};
`;
const marginBottom12 = css`
    margin-bottom: ${tokens.spacings['12']};
`;
const marginBottom16 = css`
    margin-bottom: ${tokens.spacings['16']};
`;
const marginBottom20 = css`
    margin-bottom: ${tokens.spacings['20']};
`;
const marginBottom24 = css`
    margin-bottom: ${tokens.spacings['24']};
`;
const marginBottom32 = css`
    margin-bottom: ${tokens.spacings['32']};
`;
const marginBottom40 = css`
    margin-bottom: ${tokens.spacings['40']};
`;
const marginBottom48 = css`
    margin-bottom: ${tokens.spacings['48']};
`;
const marginBottom64 = css`
    margin-bottom: ${tokens.spacings['64']};
`;

const marginBottomVariants: Record<SpacingValues, string> = {
    '0': marginBottom0,
    '4': marginBottom4,
    '8': marginBottom8,
    '12': marginBottom12,
    '16': marginBottom16,
    '20': marginBottom20,
    '24': marginBottom24,
    '32': marginBottom32,
    '40': marginBottom40,
    '48': marginBottom48,
    '64': marginBottom64,
};

const marginTop0 = css`
    margin-top: ${tokens.spacings['0']};
`;
const marginTop4 = css`
    margin-top: ${tokens.spacings['4']};
`;
const marginTop8 = css`
    margin-top: ${tokens.spacings['8']};
`;
const marginTop12 = css`
    margin-top: ${tokens.spacings['12']};
`;
const marginTop16 = css`
    margin-top: ${tokens.spacings['16']};
`;
const marginTop20 = css`
    margin-top: ${tokens.spacings['20']};
`;
const marginTop24 = css`
    margin-top: ${tokens.spacings['24']};
`;
const marginTop32 = css`
    margin-top: ${tokens.spacings['32']};
`;
const marginTop40 = css`
    margin-top: ${tokens.spacings['40']};
`;
const marginTop48 = css`
    margin-top: ${tokens.spacings['48']};
`;
const marginTop64 = css`
    margin-top: ${tokens.spacings['64']};
`;

const marginTopVariants: Record<SpacingValues, string> = {
    '0': marginTop0,
    '4': marginTop4,
    '8': marginTop8,
    '12': marginTop12,
    '16': marginTop16,
    '20': marginTop20,
    '24': marginTop24,
    '32': marginTop32,
    '40': marginTop40,
    '48': marginTop48,
    '64': marginTop64,
};

const paddingRight0 = css`
    padding-right: ${tokens.spacings['0']};
`;
const paddingRight4 = css`
    padding-right: ${tokens.spacings['4']};
`;
const paddingRight8 = css`
    padding-right: ${tokens.spacings['8']};
`;
const paddingRight12 = css`
    padding-right: ${tokens.spacings['12']};
`;
const paddingRight16 = css`
    padding-right: ${tokens.spacings['16']};
`;
const paddingRight20 = css`
    padding-right: ${tokens.spacings['20']};
`;
const paddingRight24 = css`
    padding-right: ${tokens.spacings['24']};
`;
const paddingRight32 = css`
    padding-right: ${tokens.spacings['32']};
`;
const paddingRight40 = css`
    padding-right: ${tokens.spacings['40']};
`;
const paddingRight48 = css`
    padding-right: ${tokens.spacings['48']};
`;
const paddingRight64 = css`
    padding-right: ${tokens.spacings['64']};
`;

const paddingRightVariants: Record<SpacingValues, string> = {
    '0': paddingRight0,
    '4': paddingRight4,
    '8': paddingRight8,
    '12': paddingRight12,
    '16': paddingRight16,
    '20': paddingRight20,
    '24': paddingRight24,
    '32': paddingRight32,
    '40': paddingRight40,
    '48': paddingRight48,
    '64': paddingRight64,
};

const paddingLeft0 = css`
    padding-left: ${tokens.spacings['0']};
`;
const paddingLeft4 = css`
    padding-left: ${tokens.spacings['4']};
`;
const paddingLeft8 = css`
    padding-left: ${tokens.spacings['8']};
`;
const paddingLeft12 = css`
    padding-left: ${tokens.spacings['12']};
`;
const paddingLeft16 = css`
    padding-left: ${tokens.spacings['16']};
`;
const paddingLeft20 = css`
    padding-left: ${tokens.spacings['20']};
`;
const paddingLeft24 = css`
    padding-left: ${tokens.spacings['24']};
`;
const paddingLeft32 = css`
    padding-left: ${tokens.spacings['32']};
`;
const paddingLeft40 = css`
    padding-left: ${tokens.spacings['40']};
`;
const paddingLeft48 = css`
    padding-left: ${tokens.spacings['48']};
`;
const paddingLeft64 = css`
    padding-left: ${tokens.spacings['64']};
`;

const paddingLeftVariants: Record<SpacingValues, string> = {
    '0': paddingLeft0,
    '4': paddingLeft4,
    '8': paddingLeft8,
    '12': paddingLeft12,
    '16': paddingLeft16,
    '20': paddingLeft20,
    '24': paddingLeft24,
    '32': paddingLeft32,
    '40': paddingLeft40,
    '48': paddingLeft48,
    '64': paddingLeft64,
};

const paddingBottom0 = css`
    padding-bottom: ${tokens.spacings['0']};
`;
const paddingBottom4 = css`
    padding-bottom: ${tokens.spacings['4']};
`;
const paddingBottom8 = css`
    padding-bottom: ${tokens.spacings['8']};
`;
const paddingBottom12 = css`
    padding-bottom: ${tokens.spacings['12']};
`;
const paddingBottom16 = css`
    padding-bottom: ${tokens.spacings['16']};
`;
const paddingBottom20 = css`
    padding-bottom: ${tokens.spacings['20']};
`;
const paddingBottom24 = css`
    padding-bottom: ${tokens.spacings['24']};
`;
const paddingBottom32 = css`
    padding-bottom: ${tokens.spacings['32']};
`;
const paddingBottom40 = css`
    padding-bottom: ${tokens.spacings['40']};
`;
const paddingBottom48 = css`
    padding-bottom: ${tokens.spacings['48']};
`;
const paddingBottom64 = css`
    padding-bottom: ${tokens.spacings['64']};
`;

const paddingBottomVariants: Record<SpacingValues, string> = {
    '0': paddingBottom0,
    '4': paddingBottom4,
    '8': paddingBottom8,
    '12': paddingBottom12,
    '16': paddingBottom16,
    '20': paddingBottom20,
    '24': paddingBottom24,
    '32': paddingBottom32,
    '40': paddingBottom40,
    '48': paddingBottom48,
    '64': paddingBottom64,
};

const paddingTop0 = css`
    padding-top: ${tokens.spacings['0']};
`;
const paddingTop4 = css`
    padding-top: ${tokens.spacings['4']};
`;
const paddingTop8 = css`
    padding-top: ${tokens.spacings['8']};
`;
const paddingTop12 = css`
    padding-top: ${tokens.spacings['12']};
`;
const paddingTop16 = css`
    padding-top: ${tokens.spacings['16']};
`;
const paddingTop20 = css`
    padding-top: ${tokens.spacings['20']};
`;
const paddingTop24 = css`
    padding-top: ${tokens.spacings['24']};
`;
const paddingTop32 = css`
    padding-top: ${tokens.spacings['32']};
`;
const paddingTop40 = css`
    padding-top: ${tokens.spacings['40']};
`;
const paddingTop48 = css`
    padding-top: ${tokens.spacings['48']};
`;
const paddingTop64 = css`
    padding-top: ${tokens.spacings['64']};
`;

const paddingTopVariants: Record<SpacingValues, string> = {
    '0': paddingTop0,
    '4': paddingTop4,
    '8': paddingTop8,
    '12': paddingTop12,
    '16': paddingTop16,
    '20': paddingTop20,
    '24': paddingTop24,
    '32': paddingTop32,
    '40': paddingTop40,
    '48': paddingTop48,
    '64': paddingTop64,
};

const rowGap0 = css`
    row-gap: ${tokens.spacings['0']};
`;
const rowGap4 = css`
    row-gap: ${tokens.spacings['4']};
`;
const rowGap8 = css`
    row-gap: ${tokens.spacings['8']};
`;
const rowGap12 = css`
    row-gap: ${tokens.spacings['12']};
`;
const rowGap16 = css`
    row-gap: ${tokens.spacings['16']};
`;
const rowGap20 = css`
    row-gap: ${tokens.spacings['20']};
`;
const rowGap24 = css`
    row-gap: ${tokens.spacings['24']};
`;
const rowGap32 = css`
    row-gap: ${tokens.spacings['32']};
`;
const rowGap40 = css`
    row-gap: ${tokens.spacings['40']};
`;
const rowGap48 = css`
    row-gap: ${tokens.spacings['48']};
`;
const rowGap64 = css`
    row-gap: ${tokens.spacings['64']};
`;

const rowGapVariants: Record<SpacingValues, string> = {
    '0': rowGap0,
    '4': rowGap4,
    '8': rowGap8,
    '12': rowGap12,
    '16': rowGap16,
    '20': rowGap20,
    '24': rowGap24,
    '32': rowGap32,
    '40': rowGap40,
    '48': rowGap48,
    '64': rowGap64,
};

const columnGap0 = css`
    column-gap: ${tokens.spacings['0']};
`;
const columnGap4 = css`
    column-gap: ${tokens.spacings['4']};
`;
const columnGap8 = css`
    column-gap: ${tokens.spacings['8']};
`;
const columnGap12 = css`
    column-gap: ${tokens.spacings['12']};
`;
const columnGap16 = css`
    column-gap: ${tokens.spacings['16']};
`;
const columnGap20 = css`
    column-gap: ${tokens.spacings['20']};
`;
const columnGap24 = css`
    column-gap: ${tokens.spacings['24']};
`;
const columnGap32 = css`
    column-gap: ${tokens.spacings['32']};
`;
const columnGap40 = css`
    column-gap: ${tokens.spacings['40']};
`;
const columnGap48 = css`
    column-gap: ${tokens.spacings['48']};
`;
const columnGap64 = css`
    column-gap: ${tokens.spacings['64']};
`;

const columnGapVariants: Record<SpacingValues, string> = {
    '0': columnGap0,
    '4': columnGap4,
    '8': columnGap8,
    '12': columnGap12,
    '16': columnGap16,
    '20': columnGap20,
    '24': columnGap24,
    '32': columnGap32,
    '40': columnGap40,
    '48': columnGap48,
    '64': columnGap64,
};

const alignmentStart = css`
    align-items: flex-start;
`;
const alignmentCenter = css`
    align-items: center;
`;

const alignmentEnd = css`
    align-items: flex-end;
`;
const alignmentStretch = css`
    align-items: stretch;
`;

const alignmentBaseline = css`
    align-items: baseline;
`;

const alignmentVariants: Record<AlignItemsValues, string> = {
    start: alignmentStart,
    center: alignmentCenter,
    end: alignmentEnd,
    stretch: alignmentStretch,
    baseline: alignmentBaseline,
};

const cursorDefault = css`
    cursor: default;
`;
const cursorInherit = css`
    cursor: inherit;
`;

const cursorPointer = css`
    cursor: pointer;
`;
const cursorNotAllowed = css`
    cursor: not-allowed;
`;

const cursorText = css`
    cursor: text;
`;

const cursorVariants: Record<CursorValues, string> = {
    default: cursorDefault,
    inherit: cursorInherit,
    pointer: cursorPointer,
    'not-allowed': cursorNotAllowed,
    text: cursorText,
};

const textAlignLeft = css`
    text-align: left;
`;
const textAlignRight = css`
    text-align: right;
`;

const textAlignCenter = css`
    text-align: center;
`;
const textAlignJustify = css`
    text-align: justify;
`;

const textAlignInherit = css`
    text-align: inherit;
`;

const textAlignVariants: Record<TextAlignValues, string> = {
    left: textAlignLeft,
    right: textAlignRight,
    center: textAlignCenter,
    justify: textAlignJustify,
    inherit: textAlignInherit,
};

const distributionStart = css`
    justify-content: flex-start;
`;
const distributionCenter = css`
    justify-content: center;
`;

const distributionEnd = css`
    justify-content: flex-end;
`;
const distributionStretch = css`
    justify-content: stretch;
`;

const distributionSpaceBetween = css`
    justify-content: space-between;
`;
const distributionSpaceAround = css`
    justify-content: space-around;
`;

const distributionSpaceEvenly = css`
    justify-content: space-evenly;
`;

const distributionVariants: Record<JustifyContentValues, string> = {
    start: distributionStart,
    center: distributionCenter,
    end: distributionEnd,
    stretch: distributionStretch,
    'space-between': distributionSpaceBetween,
    'space-around': distributionSpaceAround,
    'space-evenly': distributionSpaceEvenly,
};

const displayInline = css`
    display: inline;
`;

const displayInlineBlock = css`
    display: inline-block;
`;

const displayInlineFlex = css`
    display: inline-flex;
`;

const displayBlock = css`
    display: block;
`;

const displayFlex = css`
    display: flex;
`;

const displayGrid = css`
    display: grid;
`;

const displayVariants: Record<DisplayValues, string> = {
    inline: displayInline,
    'inline-block': displayInlineBlock,
    'inline-flex': displayInlineFlex,
    block: displayBlock,
    flex: displayFlex,
    grid: displayGrid,
};

const flexDirectionRow = css`
    flex-direction: row;
`;

const flexDirectionColumn = css`
    flex-direction: column;
`;

const flexDirectionVariants: Record<FlexDirectionValues, string> = {
    row: flexDirectionRow,
    column: flexDirectionColumn,
};

const positionStatic = css`
    position: static;
`;

const positionAbsolute = css`
    position: absolute;
`;

const positionFixed = css`
    position: fixed;
`;

const positionRelative = css`
    position: relative;
`;

const positionSticky = css`
    position: sticky;
`;

const positionInherit = css`
    position: inherit;
`;

const positionVariants: Record<PositionValues, string> = {
    static: positionStatic,
    absolute: positionAbsolute,
    fixed: positionFixed,
    relative: positionRelative,
    sticky: positionSticky,
    inherit: positionInherit,
};

const overflowVisible = css`
    overflow: visible;
`;

const overflowHidden = css`
    overflow: hidden;
`;

const overflowScroll = css`
    overflow: scroll;
`;

const overflowAuto = css`
    overflow: auto;
`;

const overflowVariants: Record<OverflowValues, string> = {
    visible: overflowVisible,
    hidden: overflowHidden,
    scroll: overflowScroll,
    auto: overflowAuto,
};

const textOverflowClip = css`
    text-overflow: clip;
`;

const textOverflowEllipsis = css`
    text-overflow: ellipsis;
`;

const textOverflowString = css`
    text-overflow: string;
`;

const textOverflowVariants: Record<TextOverflowValues, string> = {
    clip: textOverflowClip,
    ellipsis: textOverflowEllipsis,
    string: textOverflowString,
};

const border0 = css`
    border: ${tokens.borders['0']};
`;

const border1 = css`
    border: ${tokens.borders['1']};
`;

const border2 = css`
    border: ${tokens.borders['2']};
`;

const border3 = css`
    border: ${tokens.borders['3']};
`;

const borderVariants: Record<BorderValues, string> = {
    '0': border0,
    '1': border1,
    '2': border2,
    '3': border3,
};

const borderRadius0 = css`
    border-radius: ${tokens.radii['0']};
`;

const borderRadius4 = css`
    border-radius: ${tokens.radii['4']};
`;

const borderRadius8 = css`
    border-radius: ${tokens.radii['8']};
`;

const borderRadius12 = css`
    border-radius: ${tokens.radii['12']};
`;

const borderRadius24 = css`
    border-radius: ${tokens.radii['24']};
`;

const borderRadiusInherit = css`
    border-radius: ${tokens.radii.inherit};
`;

const borderRadiusVariants: Record<RadiusValues, string> = {
    '0': borderRadius0,
    '4': borderRadius4,
    '8': borderRadius8,
    '12': borderRadius12,
    '24': borderRadius24,
    inherit: borderRadiusInherit,
};

const whiteSpaceNormal = css`
    white-space: normal;
`;

const whiteSpaceNowrap = css`
    white-space: nowrap;
`;

const whiteSpacePre = css`
    white-space: pre;
`;

const whiteSpacePreLine = css`
    white-space: pre-line;
`;

const whiteSpacePreWrap = css`
    white-space: pre-wrap;
`;

const whiteSpaceVariants: Record<WhiteSpaceValues, string> = {
    normal: whiteSpaceNormal,
    nowrap: whiteSpaceNowrap,
    pre: whiteSpacePre,
    'pre-line': whiteSpacePreLine,
    'pre-wrap': whiteSpacePreWrap,
};

const maxWidthFull = css`
    max-width: 100%;
`;

const maxWidthVariants: Record<MaxWidthValues, string> = {
    full: maxWidthFull,
};

const lineHeightNone = css`
    line-height: 1;
`;

const lineHeightCondensed = css`
    line-height: 1.25;
`;

const lineHeightNormal = css`
    line-height: 1.5;
`;

const lineHeightRelaxed = css`
    line-height: 1.75;
`;

const lineHeightVariants: Record<LineHeightValues, string> = {
    normal: lineHeightNormal,
    none: lineHeightNone,
    condensed: lineHeightCondensed,
    relaxed: lineHeightRelaxed,
};

const appearanceNone = css`
    appearance: none;
`;

const appearanceVariants: Record<AppearanceValues, string> = {
    none: appearanceNone,
};

const outlineNone = css`
    outline: none;
`;

const outlineInherit = css`
    outline: inherit;
`;

const outlineVariants: Record<OutlineValues, string> = {
    none: outlineNone,
    inherit: outlineInherit,
};

export default {
    displayVariants,
    rowGapVariants,
    distributionVariants,
    alignmentVariants,
    textAlignVariants,
    columnGapVariants,
    flexDirectionVariants,
    paddingTopVariants,
    paddingBottomVariants,
    paddingLeftVariants,
    paddingRightVariants,
    marginTopVariants,
    marginBottomVariants,
    marginLeftVariants,
    marginRightVariants,
    overflowVariants,
    textOverflowVariants,
    whiteSpaceVariants,
    maxWidthVariants,
    minWidthVariants,
    lineHeightVariants,
    widthVariants,
    heightVariants,
    positionVariants,
    borderVariants,
    borderRadiusVariants,
    cursorVariants,
    appearanceVariants,
    outlineVariants,
};
